/**
 * The convert callback function to promise function
 * @param target
 * @param context
 * @param resolver
 * @return {Promise<T>}
 */
const thunk=<T>(target: Function,  context?: any, resolver?: {(): T})=>(...args): Promise<T>=> {
    return new Promise<T>((resolve, reject) => {
        target.apply(context, Array.prototype.slice.call(args).concat([(err: Error, result: T) => {
            if (err) {
                reject(err);
            }
            else if (resolver) {
                resolver.apply(context, args);
            }
            else {
                resolve(result);
            }
        }]));
    });
};
export default thunk;


// WEBPACK FOOTER //
// ./src/thunk.ts